import { Checkbox, Col, Form, Row, Select } from "antd";
import { useAddressHelper } from "utils/useAddressHelper";
import { FormInstance } from "antd/es/form";
import React from "react";

const { Option } = Select;

interface TemporaryAddressFormProps {
  form: FormInstance;
}

const TemporaryAddressForm: React.FC<TemporaryAddressFormProps> = ({ form }) => {
  const {
    address,
    setAddress,
    getProvinceOptions,
    getDistrictOptions,
    getMunicipalityOptions,
    getWardOptions,
  } = useAddressHelper();

  const handleSameAsPermanentAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;

    if (checked) {
      const permanentAddress = form.getFieldValue("permanentAddress");

      if (permanentAddress) {
        form.setFieldsValue({
          temporaryAddress: {
            province: permanentAddress.province,
            district: permanentAddress.district,
            municipality: permanentAddress.municipality,
            ward:permanentAddress.ward,
          },
        });
      }
    } else {
      form.setFieldsValue({
        temporaryAddress: {
          state: undefined,
          district: undefined,
          municipality: undefined,
          ward: undefined,
        },
      });
    }
  };

  return (
    <>
      <Form.Item name="sameAsPermanentAddress" valuePropName="checked">
        <Checkbox onChange={handleSameAsPermanentAddressChange}>Same as permanent address.</Checkbox>
      </Form.Item>

      <Row gutter={[48, 32]}>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Form.Item label="Province" name={["temporaryAddress", "province"]}>
            <Select
              allowClear
              placeholder="Select province"
              options={getProvinceOptions()}
              onChange={(value: string) => setAddress({ ...address, province:value})}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Form.Item name={["temporaryAddress", "district"]} label="District">
            <Select
              allowClear
              showSearch
              placeholder="Select district"
              style={{ width: "100%" }}
              optionFilterProp="children"
              filterOption={(input, option: any) => {
                return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
              }}
              onChange={(value: string) => setAddress({ ...address, district: value})}
            >
              {getDistrictOptions()?.map((district) => (
                <Option key={district?.label} value={district?.label}>
                  {district?.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Form.Item name={["temporaryAddress", "municipality"]} label="Municipality">
            <Select
              allowClear
              showSearch
              placeholder="Select municipality"
              style={{ width: "100%" }}
              optionFilterProp="children"
              filterOption={(input, option: any) => {
                return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
              }}
              onChange={(value: string) => setAddress({ ...address, municipality: value })}
            >
              {getMunicipalityOptions()?.map((municipality) => (
                <Option key={municipality?.label} value={municipality?.label}>
                  {municipality?.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Form.Item name={["temporaryAddress", "ward"]} label="Ward">
            <Select
              allowClear
              placeholder="Select ward"
              options={getWardOptions()}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default TemporaryAddressForm;